import { __decorate } from "tslib";
import { Module, VuexModule, Mutation } from 'vuex-module-decorators';
import { BRANCH_KEY, HUB_KEY, BRANCH_ADDRESS_KEY } from '@/helpers/consts';
import { sortGeograficPlaces } from '@/helpers/geografic';
import { safeSetItem } from '@/helpers/storage';
let AppointmentStore = class AppointmentStore extends VuexModule {
    appointmentCategory = null;
    appointmentRoom = null;
    locationName = null;
    appointmentPlace = null;
    branchData = null;
    branchAddress = null;
    appointmentDataToUpdate = null;
    hub = null;
    placeParsedData = null;
    appointmentOnSiteData = null;
    geograficCitiesData = [];
    client = null;
    currentAppointmentKindState = '';
    appointmentAddress = '';
    appointmentType = '';
    opportunityId = '';
    post_code = '';
    code = null;
    caseId = '';
    isCountry = false;
    viewedSlotsList = [];
    initialRoute = null;
    clearAppointmentState() {
        this.appointmentCategory = null;
        this.locationName = null;
        this.appointmentPlace = null;
        this.branchData = null;
        this.branchAddress = null;
        this.hub = null;
        this.placeParsedData = null;
        this.appointmentOnSiteData = null;
        this.geograficCitiesData = [];
        this.appointmentType = '';
        this.appointmentAddress = '';
        this.post_code = '';
        this.client = null;
        this.code = null;
    }
    clearPlaceParsedData() {
        this.placeParsedData = null;
    }
    setCurrentAppointmentKind(appointmentKind) {
        this.currentAppointmentKindState = appointmentKind;
    }
    setClientData(client) {
        this.client = client;
    }
    setAppointmentType(type) {
        this.appointmentType = type;
    }
    setWholeCountry(item) {
        this.isCountry = item;
    }
    setAppointmentCategory(appointmentCategory) {
        this.appointmentCategory = appointmentCategory;
    }
    setAppointmentRoom(appointmentRoom) {
        this.appointmentRoom = appointmentRoom;
    }
    setOpportunityId(id) {
        this.opportunityId = id;
    }
    setCaseId(id) {
        this.caseId = id;
    }
    setLocationName(locationName) {
        this.locationName = locationName;
    }
    setAppointmentPlace(place) {
        this.appointmentPlace = place;
    }
    setAppointmentDataToUpdate(appointment) {
        this.appointmentDataToUpdate = appointment;
    }
    updateViewedSlotsList(id) {
        this.viewedSlotsList = this.viewedSlotsList.includes(id) ? this.viewedSlotsList : [...this.viewedSlotsList, id];
    }
    cleanViewedSlotsList() {
        this.viewedSlotsList = [];
    }
    setPostCode(post_code) {
        this.post_code = post_code;
    }
    removeAppointmentDataToUpdate() {
        this.appointmentDataToUpdate = null;
    }
    setBranchAddress(branchAddress) {
        this.branchAddress = branchAddress;
        safeSetItem(BRANCH_KEY, JSON.stringify(branchAddress));
    }
    setAppointmentAddress(address) {
        this.appointmentAddress = address;
    }
    setBranchData(siteData) {
        this.branchData = siteData;
        safeSetItem(BRANCH_ADDRESS_KEY, JSON.stringify(siteData));
    }
    setHubData(siteData) {
        this.hub = siteData;
        safeSetItem(HUB_KEY, JSON.stringify(siteData));
    }
    setPlaceParsedData(parsedAddressData) {
        this.placeParsedData = parsedAddressData;
    }
    setGeograficCitiesData(citiesData) {
        // @ts-ignore-next-line
        this.geograficCitiesData = sortGeograficPlaces(citiesData);
    }
    setAppointmentOnSiteData(appointment) {
        this.appointmentOnSiteData = appointment;
    }
    setInitialRouteData(route) {
        this.initialRoute = route;
    }
};
__decorate([
    Mutation
], AppointmentStore.prototype, "clearAppointmentState", null);
__decorate([
    Mutation
], AppointmentStore.prototype, "clearPlaceParsedData", null);
__decorate([
    Mutation
], AppointmentStore.prototype, "setCurrentAppointmentKind", null);
__decorate([
    Mutation
], AppointmentStore.prototype, "setClientData", null);
__decorate([
    Mutation
], AppointmentStore.prototype, "setAppointmentType", null);
__decorate([
    Mutation
], AppointmentStore.prototype, "setWholeCountry", null);
__decorate([
    Mutation
], AppointmentStore.prototype, "setAppointmentCategory", null);
__decorate([
    Mutation
], AppointmentStore.prototype, "setAppointmentRoom", null);
__decorate([
    Mutation
], AppointmentStore.prototype, "setOpportunityId", null);
__decorate([
    Mutation
], AppointmentStore.prototype, "setCaseId", null);
__decorate([
    Mutation
], AppointmentStore.prototype, "setLocationName", null);
__decorate([
    Mutation
], AppointmentStore.prototype, "setAppointmentPlace", null);
__decorate([
    Mutation
], AppointmentStore.prototype, "setAppointmentDataToUpdate", null);
__decorate([
    Mutation
], AppointmentStore.prototype, "updateViewedSlotsList", null);
__decorate([
    Mutation
], AppointmentStore.prototype, "cleanViewedSlotsList", null);
__decorate([
    Mutation
], AppointmentStore.prototype, "setPostCode", null);
__decorate([
    Mutation
], AppointmentStore.prototype, "removeAppointmentDataToUpdate", null);
__decorate([
    Mutation
], AppointmentStore.prototype, "setBranchAddress", null);
__decorate([
    Mutation
], AppointmentStore.prototype, "setAppointmentAddress", null);
__decorate([
    Mutation
], AppointmentStore.prototype, "setBranchData", null);
__decorate([
    Mutation
], AppointmentStore.prototype, "setHubData", null);
__decorate([
    Mutation
], AppointmentStore.prototype, "setPlaceParsedData", null);
__decorate([
    Mutation
], AppointmentStore.prototype, "setGeograficCitiesData", null);
__decorate([
    Mutation
], AppointmentStore.prototype, "setAppointmentOnSiteData", null);
__decorate([
    Mutation
], AppointmentStore.prototype, "setInitialRouteData", null);
AppointmentStore = __decorate([
    Module({
        namespaced: true,
    })
], AppointmentStore);
export default AppointmentStore;
